import React, { useState, useEffect, useContext } from "react";
import { Alert, Box, Grid, TextField, Typography, Button, Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { Radio, RadioGroup, FormControl } from '@mui/material';
import successIcon from '../assets/payment-success-icon.png';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useMember } from '../context/MemberProfileContext';
import parse from 'html-react-parser';

import PaypalComp from '../components/PaypalComp';


const amber = '#B8860A';
const navy = '#1A3A6B';
const pageBg = '#f8f7f2';

const Section = ({ title, children }) => (
    <Box sx={{ border: '1px solid #c8d4de', borderRadius: 1.5, mb: 3, overflow: 'hidden' }}>
        <Box sx={{ bgcolor: '#e4eaf0', borderBottom: '1px solid #c8d4de', px: 3, py: 1.5 }}>
            <Typography sx={{ color: navy, fontWeight: 700, fontSize: '1rem', fontFamily: '"Roboto","Helvetica","Arial",sans-serif', textAlign: 'left' }}>
                {title}
            </Typography>
        </Box>
        <Box sx={{ p: 3 }}>
            {children}
        </Box>
    </Box>
);

export default function CulturalRegistration() {
    
    const [tempData, setTempData] = useState({
        "membershipType": "",
        "membershipGeneralAdmissionFee": 0,
        "membershipParivarNoBalaviharFee": 0,
        "membershipParivarMemberFee": 0,
        "membershipSingleChildFee": 0,
        "membershipTwoPlusChildFee": 0,
        "membershipTypeName": "",
    });
    const { accessToken, signOut } = useAuth();
    const [eventTxnsHistory, setEventTxnsHistory] = useState();

    useEffect(() => {

        console.log("Token exists or not :", accessToken);
    
        if (accessToken) {
            console.log("Token exists or not test:", accessToken);       
            memberProfileFetch(); // Load membership data
            console.log("Temp data :", tempData);
            eventTxnsHistoryFetch();

        } else {
            signOut();
            navigate('/');
        }
      }, [accessToken])         // Empty dependency array ensures this runs once on mount;

            //Chinmaya Parivar Member
    const [payloadData, setPayloadData] = useState({});
    const [eventData, setEventData] = useState({
        "balaviharYear": "",
        "membershipType": {
            "name": ""
        },
        status: "",
        "notes": "first event1",       
        transaction: {
            quantities: 1,
            itemPrice: 0,
            totalAmount: "",
            donationAmount: "",
            payerId: "",
            notes: "Multiple Events"
        },
        medical: {
                },
        "events": [

        ],
        eventType: 'Language/Cultural Event',
        feeEnabled: 0,
        parent: {
            firstName: "",
            lastName: "",
            email: "",
            mobileNumber: ""              
            
    }});
    //to populate registered children
    const { memberProfile, setMemberProfile } = useMember();
    const { eventTypes, setEventTypes } = useMember ();
    
    //const [fullNames, setFullNames] = useState();
    const [fullNames, setFullNames] = useState(
        memberProfile.children.map((child) => ({
            fullName: child.fullName,
            memberId: child.memberId, // to keep track of memberId if needed
        }))
    );
    const [email, setEmail] = useState("");
    useEffect(() => {        
        setEmail(memberProfile.primary.email); // Assign email from memberProfile
    }, [])         // Empty dependency array ensures this runs once on mount
    useEffect(() => {
            eventData.parent.firstName = memberProfile.primary.firstName;
            eventData.parent.lastName = memberProfile.primary.lastName;
            eventData.parent.email = memberProfile.primary.email;
            eventData.parent.mobileNumber = memberProfile.primary.mobileNumber.replace(/[-\s]/g, ''); // Remove hyphens and spaces    
        }, [])         // Empty dependency array ensures this runs once on mount
    

    const [culturalEventTypes, setCulturalEventTypes] = useState([]);
    const [eventDescription, setEventDescription] = useState("");
    const [languageEventType, setLanguageEventType] = useState(0);

    useEffect(() => {
        console.log("Event Types in Cultural Registration:", eventTypes);
        if (eventTypes && eventTypes.length > 0) {
            // Find the eventTypeId of the record where name === 'Languages'
            setLanguageEventType(eventTypes.find((eventType) => eventType.name === 'Language/Cultural Event'));
            const parentLanguageEventType = eventTypes.find((eventType) => eventType.name === 'Language/Cultural Event');
            if (parentLanguageEventType) {
                const filteredEventTypes = eventTypes.filter(
                    (eventType) => eventType.parentEventTypeId === parentLanguageEventType.eventTypeId
                );
                setCulturalEventTypes(filteredEventTypes);
                console.log("Filtered Cultural Event Types:", filteredEventTypes);
            } else {
                console.log("No event type found with the name 'Languages'");
                setCulturalEventTypes([]); // Set to an empty array if no matching record is found
            }
        }
    }, [eventTypes]);

    const handleEventSelection = (e, child, eventType) => {
        const isChecked = e.target.checked;
      
        console.log("Full Name: ", child.fullName, child.memberId, eventType, eventType.eventTypeId, eventType.name, isChecked, eventTypes.eventTypeId);
      
        setEventData((prevEventData) => {
            const updatedEvents = [...prevEventData.events];
        
            if (isChecked) {
              // Add the event if the checkbox is checked
              updatedEvents.push({
                memberId: child.memberId,
                eventTypeId: eventType.eventTypeId,
              });
            } else {
              // Remove the event if the checkbox is unchecked
              const indexToRemove = updatedEvents.findIndex(
                (event) =>
                  event.memberId === child.memberId &&
                  event.eventTypeId === eventType.eventTypeId
              );
              if (indexToRemove !== -1) {
                updatedEvents.splice(indexToRemove, 1);
              }
            }
                
            return {
              ...prevEventData,
              events: updatedEvents,
            };
          });
      };
      // 
      const memberPrices = {}; // Object to store prices for each child
      const memberPaid = {}; // Object to store already paid amounts for each child

    // Function to handle radio selection for a member
    const handleEventRadioChange = (memberId, eventTypeId) => {
    setEventData((prev) => {
        const updatedEvents = [
        ...prev.events.filter(ev => ev.memberId !== memberId),
        { memberId, eventTypeId: parseInt(eventTypeId, 10) } // Ensure eventTypeId is an integer
        ];
        // After updating, calculate the new total
        console.log("Updated Events after radio change:", updatedEvents);
        setTotalAmount(calculateTotalPrice(updatedEvents));
        return { ...prev, events: updatedEvents };
    });
    };

    // Calculate total price based on selected events
    const calculateTotalPrice = (events = eventData.events) => {
    let total = 0;
    events.forEach((event) => {
        const eventType = culturalEventTypes.find(
        (type) => String(type.eventTypeId) === String(event.eventTypeId)
        );
        console.log("Event data in calculateTotalPrice :", eventData.events, event.memberId, eventType, culturalEventTypes);
        if (eventType && eventType.price) {
        total += parseInt(eventType.price, 10);
                        console.log("Event Type price:", eventType.price, "for Event:", event);

        }
        
    });
    console.log("Calculated total price:", total, "for events:", events);
    return total;
    };

    const [sessions, setSessions] = useState();
    const [studentFields, setStudentFields] = useState([]);
    const [error, setError] = useState(null);
    
    const [rulesAccepted, setRulesAccepted] = useState(false); // State to manage checkbox
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const { memberships, setMemberships} = useMember();
    const [parivarMember, setParivarMember] = useState(false);
   
    
    const [ticketPrice, setTicketPrice] = useState(0);  
    console.log("Enter Cultural Registration: ", eventData, culturalEventTypes, eventTypes);



  useEffect(() => {
    console.log("inside membership changes :");

      if (memberships && memberships.membershipTypes && memberships.membershipTypes.length > 0) {
          loadMembershipFeeData(); // Load membership fee data
          setSessions(memberships.availableSessions.map((child) => child.sessionName));
              console.log("inside membership changes1 :");
     
      }  
     
    if (memberships.registeredSessions && memberships.registeredSessions.length > 0) {
        setStudentFields(memberships.registeredSessions.map((session) => ({
            memberType: "child",
            firstName: session.memberEntity.firstName,
            lastName: session.memberEntity.lastName,
            fullName: session.memberEntity.fullName,
            session: session.sessionEntity.sessionName,
            grade: session.gradeEntity.grade,
        })));
        setNoOfPeople(memberships.registeredSessions.length);
            console.log("inside membership changes2 :");

    }
    // set the balavihar year in eventData from the memberships data
    if (memberships.balaviharYear) {
        eventData.balaviharYear = memberships.balaviharYear;
    }

    if ((memberships.status === "ACTIVE") && (memberships.currentMembership.membershipTypesEntity.name === "Chinmaya Parivar Member")) 
        {
        setParivarMember(true);
        };

  }, [memberships]);


    const [inputFields, setInputFields] = useState(eventData.transaction);
        const [feeEnabled, setFeeEnabled] = useState(0);
    const [parivarEnabled, setParivarEnabled] = useState(false);

    const [donation, setDonation] = useState(0);
    const [totalAmount, setTotalAmount] = useState(inputFields.quantities * inputFields.itemPrice);
    const [noOfPeople, setNoOfPeople] = useState(0);
 
    const total = () => {
        inputFields.donationAmount = donation;
        inputFields.totalAmount = totalAmount;
        eventData.transaction = inputFields;
    }
    total();
    
    useEffect(() => {

        setTicketPrice(calculateTotalPrice());
        //console.log("RUn 0 calculate price :", (eventData.events), ticketPrice, totalAmount);

        if (parivarEnabled || parivarMember) {
            setTicketPrice(tempData.membershipParivarMemberFee - memberships.totalAmountPaid);
            if (tempData.membershipType === "Balavihar" || memberships.status === "ACTIVE" ) {
                setTicketPrice(tempData.membershipParivarMemberFee - memberships.totalAmountPaid);
            }
            if (tempData.membershipType === "GeneralAdmission" || memberships.status === "ACTIVE" ) {
                setTicketPrice(tempData.membershipParivarNoBalaviharFee - memberships.totalAmountPaid);
            }
        }

        eventData.transaction.itemPrice = ticketPrice;

        if (feeEnabled) {
            setTotalAmount(((parseInt(ticketPrice) + parseInt(donation)) * 1.03).toFixed(2));
        } else {
            setTotalAmount((parseInt(ticketPrice) + parseInt(donation)) * 1.00);
        }

        eventData.transaction.totalAmount = totalAmount;
        console.log("Run 1 calculate price :", (eventData.events), ticketPrice, totalAmount);

    }, [noOfPeople, donation, feeEnabled, parivarEnabled, tempData.membershipType, ticketPrice, eventData.events, memberships.totalAmountPaid, memberships.status, parivarMember]);


        
          const eventTxnsHistoryFetch = async () => {
          let response, data;
          try {    
            const response = await fetch(`${API_URL}/gquery`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'x-cmdfw-jwt-token': `${accessToken}`,
              },
                body: JSON.stringify({
                    query: `
                            query {
                              eventsHistory {
                                  events {
                                      memEventsId
                                      status
                                      startDate
                                      endDate
                                      memberEntity {
                                          memberId
                                          memberType
                                          fullName
                                      }
                                      eventTypesEntity {
                                          eventTypeId
                                          name
                                          eventYear
                                      }
                                      transactionEntity {
                                          transactionId
                                          totalAmount
                                          paymentStatus
                                          createdAt
                                      }
                                  }
                                }
                            }
                          `,
              }),
            });
      
            const data = await response.json();
            if (response.ok) {
              console.log("Event history data API call:", response, data.data.eventsHistory.events);
    
              setEventTxnsHistory(data.data.eventsHistory.events);
            } else {
              if (response.status === 403) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'OTP expired');
                //handleLogout(); // Logout user
              } else {
                if (!response.ok) {
                  const errorData = await response.json();
                  throw new Error(errorData.message || 'Membership fetch failed');
                }
              }
            }
          } catch (error) {
            console.error("Error fetching Event Txns History :", error);
            //signOut();
            //navigate('/');
          }
        };

    const getRegisteredEventTypeIdForMember = (memberId) => {
        const registered = eventTxnsHistory
            ? eventTxnsHistory.find(
                txn =>
                    txn.status === "ACTIVE" &&
                    txn.memberEntity.memberId === memberId 
                    && culturalEventTypes.some(et => String(et.eventTypeId) === String(txn.eventTypesEntity.eventTypeId))
                    && !txn.eventTypesEntity.name.toLowerCase().includes('self study')
                        )
            : null;
        console.log("Registered Event Type ID for Member:", memberId, registered);
        return registered ? parseInt(registered.eventTypesEntity.eventTypeId, 10) : '';
    };


    // Filter cultural events to find self-study events
    const selfStudyEvents = culturalEventTypes.filter(
        eventType => eventType.name.toLowerCase().includes('self study')
    );
    const [selfStudySelections, setSelfStudySelections] = useState({});
    const [selfStudyChecked, setSelfStudyChecked] = useState({});
    const handleSelfStudyChange = (memberId, eventTypeId, checked) => {
        setSelfStudyChecked(prev => ({
            ...prev,
            [memberId]: {
                ...(prev[memberId] || {}),
                [eventTypeId]: checked
            }
        }));
        setEventData((prev) => {
            let updatedEvents = [...prev.events];


            if (checked) {
                // Only add if not already present
                const exists = updatedEvents.some(
                    ev => ev.memberId === memberId && ev.eventTypeId === parseInt(eventTypeId, 10)
                );
                if (!exists) {
                    updatedEvents.push({ memberId, eventTypeId: parseInt(eventTypeId, 10) });
                }
            } else {
                // Remove if unchecked
                updatedEvents = updatedEvents.filter(
                    ev => !(ev.memberId === memberId && ev.eventTypeId === parseInt(eventTypeId, 10))
                );
            }

            return { ...prev, events: updatedEvents };
        });
    };
       
    // Function to get registered self-study event IDs for a member
    const getRegisteredSelfStudyEventIdsForMember = (memberId) => {
        if (!eventTxnsHistory) return [];
        return eventTxnsHistory
            .filter(
                txn =>
                    txn.status === "ACTIVE" &&
                    txn.memberEntity.memberId === memberId &&
                    txn.eventTypesEntity.name.toLowerCase().includes('self study')
            )
            .map(txn => parseInt(txn.eventTypesEntity.eventTypeId, 10));
    };

    const handleLogout = () => {
        signOut();
        navigate('/');
      };

    const memberProfileFetch = async () => {
        console.log("Token value B", accessToken);
        let response, data;
        try {    
          //const response = await fetch('https://membership.cmdfw.org/api/gquery', {
          const response = await fetch(`${API_URL}/gquery`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-cmdfw-jwt-token': `${accessToken}`,
            },
              body: JSON.stringify({
                  query: `
                          query {
                            memberships {
                                balaviharYear
                                balaviharPeriod
                                status
                                totalAmountPaid
                                membershipTypes {
                                    membershipTypeId
                                    name
                                    startDate
                                    endDate
                                    bvPrice
                                    childQuantities
                                }
                                availableSessions {
                                    sessionId
                                    center
                                    sessionName
                                    grades {
                                        gradeId
                                        grade
                                    }
                                }
                                registeredSessions{
                                    bvRegistrationId
                                    regStartDate
                                    regEndDate
                                    status
                                    memberEntity{
                                        firstName
                                        lastName
                                        fullName
                                    }
                                    sessionEntity {
                                        sessionId
                                        center
                                        sessionName
                                    }
                                    gradeEntity{
                                        gradeId
                                        grade
                                    }
                                }
                                currentMembership {
                                    membershipId
                                    startDate
                                    endDate
                                    status
                                    notes
                                    bvYear
                                    createdAt 
                                    createdBy 
                                    membershipTypesEntity{
                                        membershipTypeId
                                        name
                                        startDate
                                        endDate
                                    }
                                    transactionEntity {
                                        transactionId
                                        eventTypesEntity {
                                            eventTypeId
                                            name
                                            eventYear
                                        }
                                        totalAmount
                                        paymentStatus
                                        createdAt 
                                        createdBy 
                                    }
                                }
                            }
                          }
                        `,
            }),
          });
    
          const data = await response.json();
          if (response.ok) {
            setMemberships(data.data.memberships);
            console.log("Membership data after API call:", data, response);
          } else {
            if (response.status === 403) {
              const errorData = await response.json();
              handleLogout(); // Logout user
              throw new Error(errorData.message || 'OTP expired');
            } else {
              if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Membership fetch failed');
              }
            }
          }
        } catch (error) {
          console.error("Error fetching Membership Profile :", error);
          signOut();
          //navigate('/');
        }
      };
    function loadMembershipFeeData() {
        //console.log("Membership Profile data to load fees  :", memberships);            

        memberships.membershipTypes.forEach((membershipType) => {
            if (membershipType.name === 'Chinmaya Parivar Member') {
                setTempData((prevData) => ({ ...prevData, membershipParivarMemberFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'General Member (NO Balavihar)') {
                setTempData((prevData) => ({ ...prevData, membershipGeneralAdmissionFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'Balavihar (Single Child)') {
                setTempData((prevData) => ({ ...prevData, membershipSingleChildFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'Balavihar (2+ Children)') {
                setTempData((prevData) => ({ ...prevData, membershipTwoPlusChildFee: membershipType.bvPrice }));
            } else if (membershipType.name === 'Chinmaya Parivar (NO Balavihar)') {
                setTempData((prevData) => ({ ...prevData, membershipParivarNoBalaviharFee: membershipType.bvPrice }));
            }
        });
        

    };
    const checkoutHandler = (e) => {
        e.preventDefault();
        setError(null);
        // Skip payment if total amount is zero
        if (totalAmount >0 ) {        
            eventData.status = "pending";
        } else {
            eventData.status = "paid";
            setSuccess(true); // Skip payment if total amount is zero
        }
        setPayloadData(eventData); 

        //    console.log("transaction before sent to SQS:", (inputFields));
        if (sendToServer()) {
            console.log("checkout true");
            //setCheckout(true);
        } else {
            //setCheckout(false);
            console.log("checkout false");
        }
    };
    async function sendToServer() {
        const maxRetries = 3; // Maximum number of retries
        let attempt = 0;
        let url_link = `${API_URL}/events`;
        console.log("transaction before sent to Database:", eventData, url_link);


        while (attempt < maxRetries) {
            try {
            //const response = await fetch(`${API_URL}/events`, {
            const response = await fetch(url_link, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "x-cmdfw-jwt-token": `${accessToken}`,
                },
                body: JSON.stringify(eventData),
            });
            console.log('API response:', response.data);
            if (response.ok) {
                setCheckout(true);
                return true; // Success
            }
            if (response.status === 403) {
                const errorData = await response.json();
                handleLogout(); // Logout user
                throw new Error(errorData.message || 'OTP expired');
              } else {
                const errorData = await response.json();
                console.error('API Error:', errorData);
                setError(errorData.message);
                return false; // API call failed
                //throw new Error(errorData.message || 'API call failed');
            }
        } catch (error) {
            console.error(`Attempt ${attempt + 1} failed:`, error);
            attempt++;

            if (attempt >= maxRetries) {
                console.error('All retry attempts failed.');
                setCheckout(false);
                setError("Failed to send data to the server. Please try again later.");
                return false; // Return false after all retries fail
            }

            console.log(`Retrying API call... (${attempt}/${maxRetries})`);
 
        }
    }
    }


    function feeSwitchHandler(e) {
        setFeeEnabled(e.target.checked);
        eventData.feeEnabled = e.target.checked ;
        //console.log("Event data feeSwitchHandler :", (eventData.feeEnabled));
    }
    function parivarSwitchHandler(e) {
        setParivarEnabled(e.target.checked);
        eventData.parivarEnabled = e.target.checked ;
        if (e.target.checked) {
            setTicketPrice(tempData.membershipParivarMemberFee - memberships.totalAmountPaid);
            eventData.membershipType.name = "Chinmaya Parivar Member"; // Set membership type to "Chinmaya Parivar Member"
        } else {
            eventData.membershipType.name = ""; // Reset membership type if unchecked
        }
    }

    function handleBack() {
        setCheckout(false);
    }

    function handleDonation(e) {
        setInputFields({ ...inputFields, [e.target.name]: parseInt(e.target.value) });
        if (e.target.value >= 0) {
            setDonation(parseInt(e.target.value));
        }
    };

    const handleCancel = () => {
        navigate('/EventTypesForm');
        // Add any additional save logic here, such as API calls
      };
    
 
    const [success, setSuccess] = useState(false)
    const [checkout, setCheckout] = useState(false)

    return (
        <Box sx={{ bgcolor: pageBg, minHeight: '100vh', py: 4, px: { xs: 2, md: 4 }, display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ width: '100%', maxWidth: 760, bgcolor: '#fff', borderRadius: 2, boxShadow: 3, overflow: 'hidden', alignSelf: 'flex-start' }}>

                <Box sx={{ bgcolor: navy, px: { xs: 3, md: 5 }, py: 3 }}>
                    <Typography variant="h5" sx={{ color: '#fff', fontFamily: 'Georgia, serif', fontWeight: 700, letterSpacing: 0.5 }}>
                        Cultural / Language Class Registration
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#c5d8ea', mt: 0.5 }}>
                        CMDFW Event Registration
                    </Typography>
                </Box>

                <Box sx={{ px: { xs: 2, md: 3 }, py: 3 }}>
                    {checkout ? (
                        success ? (
                            <Box sx={{ textAlign: 'center', py: 4 }}>
                                <img src={successIcon} className="Success-icon" alt="success" />
                                <Typography variant="h5" sx={{ color: navy, fontFamily: 'Georgia, serif', mt: 2, mb: 1 }}>
                                    Thank You for Registering!
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#555' }}>
                                    A confirmation email will be sent to <b>{email}</b>
                                </Typography>
                            </Box>
                        ) : (
                            <Box>
                                <PaypalComp eventData={eventData} setSuccess={setSuccess} payloadData={payloadData} />
                                <Button variant="outlined" sx={{ mt: 3, borderColor: '#aaa', color: '#555' }} onClick={() => handleBack()}>
                                    Back
                                </Button>
                            </Box>
                        )
                    ) : (
                        <form onSubmit={checkoutHandler}>

                            <Section title="Event Details">
                                <Typography variant="body2" sx={{ fontWeight: 600, color: navy, mb: 0.5 }}>
                                    {languageEventType.name}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#555' }}>
                                    {parse(languageEventType.desc || "")}
                                </Typography>
                            </Section>

                            {memberships.status === "ACTIVE" ? (
                                <Box sx={{ bgcolor: '#e8f5e9', border: '1px solid #a5d6a7', borderRadius: 1, p: 2, mb: 3 }}>
                                    <Typography variant="body2">Membership: <b>Active</b> — {memberships.balaviharPeriod}</Typography>
                                    <Typography variant="body2">Type: <b>{memberships.currentMembership.membershipTypesEntity.name}</b></Typography>
                                </Box>
                            ) : (
                                <Box sx={{ bgcolor: '#fff3e0', border: '1px solid #ffcc80', borderRadius: 1, p: 2, mb: 3 }}>
                                    <Typography variant="body2" sx={{ color: '#bf360c', fontWeight: 700, mb: 0.5 }}>Membership expired</Typography>
                                    <Typography variant="body2" sx={{ mb: 1.5 }}>
                                        Please renew your membership for <b>{memberships.balaviharPeriod}</b> before registering for Language/Cultural classes.
                                    </Typography>
                                    <Button onClick={handleCancel} variant="outlined" size="small" sx={{ borderColor: amber, color: amber }}>Cancel</Button>
                                    <Typography variant="caption" sx={{ display: 'block', mt: 2, color: '#777' }}>
                                        Questions? <a href="mailto:membership@cmdfw.org" style={{ color: amber }}>membership@cmdfw.org</a>
                                    </Typography>
                                </Box>
                            )}

                            {(tempData.membershipType === "Balavihar" || memberships.status === "ACTIVE") && (
                                <Section title="Cultural / Language Class Registration">
                                    <Grid container spacing={2}>
                                        {fullNames.map((child, fullNameIndex) => {
                                            const registeredEventTypeId = getRegisteredEventTypeIdForMember(child.memberId);
                                            const registeredSelfStudyIds = getRegisteredSelfStudyEventIdsForMember(child.memberId);
                                            const selectedEventTypeId = registeredEventTypeId ||
                                                (eventData.events.find(ev => ev.memberId === child.memberId)?.eventTypeId || '');
                                            const isRegistered = Boolean(registeredEventTypeId);
                                            const selectedMainEventType = culturalEventTypes.find(
                                                et => et.eventTypeId === parseInt(selectedEventTypeId, 10)
                                            );
                                            let filteredSelfStudyEvents = [];
                                            if (selectedMainEventType) {
                                                if (selectedMainEventType.name === 'Shlokathon') {
                                                    filteredSelfStudyEvents = culturalEventTypes.filter(et => et.name === 'Gita Chanting-Self Study');
                                                } else if (selectedMainEventType.name === 'Gita Chanting') {
                                                    filteredSelfStudyEvents = culturalEventTypes.filter(et => et.name === 'Shlokathon-Self Study');
                                                } else {
                                                    filteredSelfStudyEvents = culturalEventTypes.filter(
                                                        et => et.name === 'Gita Chanting-Self Study' || et.name === 'Shlokathon-Self Study'
                                                    );
                                                }
                                            }
                                            return (
                                                <Grid item xs={12} key={fullNameIndex}>
                                                    <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 2 }}>
                                                        <FormControl component="fieldset" fullWidth>
                                                            <Typography sx={{ fontWeight: 600, color: navy, mb: 1 }}>{child.fullName}</Typography>
                                                            <RadioGroup
                                                                name={`event-radio-group-${child.memberId}`}
                                                                value={selectedEventTypeId}
                                                                onChange={(e) => handleEventRadioChange(child.memberId, e.target.value)}
                                                                disabled={isRegistered}
                                                            >
                                                                {culturalEventTypes
                                                                    .filter(eventType => !eventType.name.toLowerCase().includes('self study'))
                                                                    .map((eventType, eventTypeIndex) => (
                                                                        <FormControlLabel
                                                                            key={eventTypeIndex}
                                                                            value={eventType.eventTypeId}
                                                                            control={<Radio sx={{ '&.Mui-checked': { color: amber } }} />}
                                                                            label={eventType.name}
                                                                            disabled={isRegistered}
                                                                        />
                                                                    ))}
                                                            </RadioGroup>
                                                            {selectedEventTypeId && !isRegistered && (
                                                                <Typography variant="body2" sx={{ mt: 1, mb: 0.5, color: '#555' }}>
                                                                    <b>Select Self Study options if interested:</b>
                                                                </Typography>
                                                            )}
                                                            {filteredSelfStudyEvents.map((eventType) => (
                                                                <FormControlLabel
                                                                    key={eventType.eventTypeId}
                                                                    control={
                                                                        <Checkbox
                                                                            checked={
                                                                                (selfStudyChecked[child.memberId] && selfStudyChecked[child.memberId][eventType.eventTypeId]) ||
                                                                                registeredSelfStudyIds.includes(parseInt(eventType.eventTypeId, 10))
                                                                            }
                                                                            onChange={e => handleSelfStudyChange(child.memberId, eventType.eventTypeId, e.target.checked)}
                                                                            sx={{ '&.Mui-checked': { color: amber } }}
                                                                        />
                                                                    }
                                                                    label={eventType.name}
                                                                />
                                                            ))}
                                                        </FormControl>
                                                    </Box>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </Section>
                            )}

                            {memberships.status === "ACTIVE" && (
                                <>
                                    <Section title="Payment Summary">
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <TextField fullWidth disabled label="Balavihar Fee Paid Amount ($)"
                                                    type="number" variant="outlined" value={memberships.totalAmountPaid} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={parivarEnabled} disabled={parivarMember}
                                                            onChange={parivarSwitchHandler}
                                                            sx={{ '&.Mui-checked': { color: amber } }} />
                                                    }
                                                    label={`$${tempData.membershipParivarMemberFee} — Upgrade to Parivar membership (all events included)`}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField fullWidth label="Additional Donation ($)" type="number"
                                                    name="donation" variant="outlined" value={donation} onChange={handleDonation} />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={feeEnabled} onChange={feeSwitchHandler}
                                                            sx={{ '&.Mui-checked': { color: amber } }} />
                                                    }
                                                    label="Add 3% to cover credit card processing fees"
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <TextField fullWidth disabled label="Total Amount ($)" type="number"
                                                    variant="outlined"
                                                    inputProps={{ style: { fontSize: 22, fontWeight: 700, color: navy } }}
                                                    InputLabelProps={{ style: { fontSize: 16 } }}
                                                    value={totalAmount} />
                                            </Grid>
                                        </Grid>
                                    </Section>

                                    <Section title="Waiver">
                                        <Typography variant="body2" sx={{ mb: 1.5 }}>
                                            Please read the waiver before proceeding:{' '}
                                            <a href="https://membership.cmdfw.org/docs/cmdfw-waiver.pdf" target="_blank" rel="noopener noreferrer" style={{ color: amber }}>
                                                Open PDF
                                            </a>
                                        </Typography>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={rulesAccepted} onChange={(e) => setRulesAccepted(e.target.checked)}
                                                    sx={{ '&.Mui-checked': { color: amber } }} />
                                            }
                                            label="I have read and agree to the rules and policies"
                                        />
                                    </Section>

                                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                                    <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                                        <Button onClick={handleCancel} variant="outlined" sx={{ borderColor: '#bbb', color: '#555', px: 3 }}>
                                            Cancel
                                        </Button>
                                        <Tooltip title={!rulesAccepted ? "Please accept the rules and policies" : ""}>
                                            <span>
                                                <Button type="submit" variant="contained" disabled={!rulesAccepted}
                                                    sx={{ bgcolor: amber, color: '#fff', fontWeight: 700, px: 4,
                                                        '&:hover': { bgcolor: '#9a6f08' },
                                                        '&.Mui-disabled': { bgcolor: '#e8d5a0', color: '#fff' } }}>
                                                    Proceed to Checkout
                                                </Button>
                                            </span>
                                        </Tooltip>
                                    </Box>

                                    <Typography variant="caption" sx={{ display: 'block', mt: 3, color: '#999' }}>
                                        Questions? Contact us at{' '}
                                        <a href="mailto:membership@cmdfw.org" style={{ color: amber }}>membership@cmdfw.org</a>
                                    </Typography>
                                </>
                            )}
                        </form>
                    )}
                </Box>
            </Box>
        </Box>
    );
}